import { render } from "./EditItem.vue?vue&type=template&id=50d46da9"
import script from "./EditItem.vue?vue&type=script&lang=js"
export * from "./EditItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/klous/Documents/beye/src/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__